import { SelectOption } from '../../../shared/form-controls';
import { RouteGroupScheduleVersion } from '@apiEntities/route-group/route-group';

export const scheduleVersionToSelectOption = (version: RouteGroupScheduleVersion): SelectOption => {
  return {
    displayLabel: version.version,
    value: version.routeGroupScheduleId,
  };
};
